// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
// GLOBALS
// ----------------------------------------------------------------------------- */

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Quicksand', sans-serif;
    font-size: 16px;
    line-height: 1.5;
}

a{ text-decoration: none; }
a:hover { text-decoration: underline; cursor: pointer;}

p, li, a, button{ font-weight: 500; }

button:hover{ cursor: pointer; }

p{ line-height: 1.2; }

main{ margin: 270px 80px; }
.main-user{ margin: 140px 80px 100px 80px; }

.flex{ display: flex; }

.column{
  display: flex;
  flex-direction: column;
}

.between{
  display: flex;
  justify-content: space-between;
}

.end{ justify-content: flex-end; }

.flex-center{
  display: flex;
  justify-content: center;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-end{ align-items: end; }

.wrap{
  display: flex;
  flex-wrap: wrap;
}

.none{ display: none; }

.verde{ color: #007932; }
.rojo{ color: #8E151D; }
.blanco{ color: white; }
.negro{ color: black; }
.fondo-verde{ background-color: #007932; }
.fondo-blanco{ background-color: white; }
.fondo-rojo{ background-color: #8E151D; }

.mayusculas { text-transform: uppercase; }
.capitalize { text-transform: capitalize; }

.font-18{font-size: 18px;}
.font-21{font-size: 21px;}
.font-24{font-size: 24px;}

.text-center{text-align: center;}
.text-left{text-align: left;}
.text-right{text-align: right;}

.bold{ font-weight: bold; }

.fixed{ position: fixed; }
.absolute{ position: absolute; }
.relative{ position: relative; }

.w-content{ width: fit-content; }
.w-10p{ width: 10%; }
.w-20p{ width: 20%; }
.w-25p{ width: 25%; }
.w-30p{ width: 30%; }
.w-50p{ width: 50%; }
.w-60p{ width: 60%; }
.w-70p{ width: 70%; }
.w-75p{ width: 75%; }
.w-80p{ width: 80%; }
.w-90p{ width: 90%; }
.w-100p{ width: 100%; }

.w-50{ width: 50px; }
.w-25{ width: 25px; }
.w-65{ width: 65px; }
.w-75{ width: 75px; }
.w-40{ width: 40px; }
.w-80{ width: 80px; }
.w-90{ width: 90px; }
.w100{ width: 100px; }
.w-100{ width: 100%; }
.w-120{ width: 120px; }
.w-150{ width: 150px; }
.w-175{ width: 175px; }
.w-180{ width: 180px; }
.w-200{ width: 200px; }
.w-250{ width: 250px; }
.w-275{ width: 275px; }
.w-300{ width: 300px; }
.w-325{ width: 325px; }
.w-350{ width: 350px; }
.w-400{ width: 400px; }
.w-450{ width: 450px; }
.w-500{ width: 500px; }
.w-550{ width: 550px; }

.gap-5{ gap: 5px; }
.gap-10{ gap: 10px; }
.gap-15{ gap: 15px; }
.gap-20{ gap: 20px; }
.gap-25{ gap: 25px; }
.gap-30{ gap: 30px; }
.gap-50{ gap: 50px; }
.gap-75{ gap: 75px; }
.gap-100{ gap: 100px; }
.gap-150{ gap: 150px; }
.gap-200{ gap: 200px; }
.gap-10-20{gap: 10px 20px;}

.pb-5{ padding-bottom: 5px; }
.pb-10{ padding-bottom: 10px; }
.mb-5{ margin-bottom: 5px; }
.mb-10{ margin-bottom: 10px; }
.mb-20{ margin-bottom: 20px; }
.mb-25{ margin-bottom: 25px; }
.mb-30{ margin-bottom: 30px; }
.mb-40{ margin-bottom: 40px; }
.mb-50{ margin-bottom: 50px; }
.mb-75{ margin-bottom: 75px; }
.mb-100{ margin-bottom: 100px; }
.mt-5{ margin-top: 5px;}
.mt-10{ margin-top: 10px;}
.mt-15{ margin-top: 15px;}
.mt-20{ margin-top: 20px;}
.mt-30{ margin-top: 30px;}
.mt-50{ margin-top: 50px;}
.ml-5{ margin-left: 5px;}
.ml-10{ margin-left: 10px;}
.ml-40{ margin-left: 40px;}
.pl-5{ padding-left: 5px;}
.pl-10{ padding-left: 10px;}
.pl-20{ padding-left: 20px;}
.mr-20{margin-right: 20px;}

.no-border{ border: none; }

.landing-page{ margin-bottom: 130px;
    margin-top: 80px; }


.cursor{ cursor: pointer; }

ul{ list-style-position: inside; }

.boton{
  padding: 10px 15px;
  border: 2px solid #007932;
  border-radius: 12px;
  background-color: white;
  color: #007932;
  height: fit-content;
}

.boton:hover{
  color: white;
  background-color: #007932; 
  text-decoration: none;
}

/* -- Estilo para los titulos de las paginas de usuario -- */
.titulo-user{
  font-size: 242x;
  line-height: 1.1;
  gap: 10px;
}

.titulo-user svg{ font-size: 36px; }


/* -----------------------------------------------------------------------------
// DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE
// ----------------------------------------------------------------------------- */
.landing-page h1, .landing-page h2{
  font-size: 24px;
  margin-bottom: 20px;
  line-height: 1.2;
}

.landing-page p{margin-bottom: 15px;}
.landing-page li{margin-bottom: 10px;}

.descripcion-plataforma .red-empleo{
  margin-top: 20px;
  gap: 20px;
  align-items: center;
}

.descripcion-plataforma .logo-red{
  width: 120px;
  padding-top: 3px;
}

.descripcion-plataforma .red-empleo a, .descripcion-plataforma .red-empleo p{
  font-size: 17px;
  line-height: 1.2;
}

.descripcion-plataforma .red-empleo a{
  color: #007932; 
  text-decoration: underline;
}

.descripcion-plataforma .red-empleo a:hover{ font-weight: bold; }
.descripcion-plataforma .sirve{ width: 35%; }


/* -----------------------------------------------------------------------------
// PROMOCIÓN APP
// ----------------------------------------------------------------------------- */
.app-contacto{
  justify-content: space-between;
  padding: 25px 100px 25px 100px;
}

.promocion-app{
  align-items: center;
  gap: 30px;
}

.promocion-app .promocion{ 
  min-width: 300px; 
  max-width: 300px; 
}

.promocion-app .texto, .promocion-app .texto span{
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2;
}

.promocion-app .descarga{ margin: 30px 0 0 0; }

.promocion-app .tiendas{ 
  gap: 7.5px;
  margin-left: -4px;
}

.promocion-app .tiendas button:hover{ background-color: white; }

.promocion-app .tiendas img{  width: 120px; }
.promocion-app .tiendas img:hover{  opacity: 0.7; }

/* -----------------------------------------------------------------------------
// FORMULARIO CONTACTO
// ----------------------------------------------------------------------------- */
.formulario-contacto{
border-radius: 20px;
padding: 30px 35px 40px 35px;
min-width: 400px;
}

.formulario-contacto h2{
  margin: 0px auto 20px auto;
  width: 300px;
  text-align: center;
  }

.formulario-contacto .campo{ margin-bottom: 25px; }

.formulario-contacto input,
.formulario-contacto textarea{ 
border: none;
border-bottom: 1px solid #fff;
padding: 2px 5px 1px 5px;
background-color: transparent;
color: white;
}

.formulario-contacto .campo textarea{ 
border: 1px solid #fff; 
border-radius: 5px;
margin-top: 2.5px;
}

.formulario-contacto input::placeholder,
.formulario-contacto textarea::placeholder{ color: rgba(255, 255, 255, 0.5) !important; }

.formulario-contacto button:hover{ border: 2px solid white; }

/* -----------------------------------------------------------------------------
// ENLACES LEGALES
// ----------------------------------------------------------------------------- */
.enlaces-legales{ 
  flex-wrap: wrap;
  gap: 20px 30px; 
}

.enlaces-legales a{ color: black; }
.enlaces-legales a:hover{ text-decoration: underline; }

@media(min-width: 1024px){
  .landing-page {
    margin-top: 210px;
}
}

/* -----------------------------------------------------------------------------
// RESPONSIVE
// ----------------------------------------------------------------------------- */
  @media (max-width: 1400px) {
    /* PROMOCIÓN APP */
    .app-contacto{ padding: 25px 0px 25px 0px; }
  }


  
  
  @media (max-width: 1200px) {
    section { margin: 60px 0px; }
    
    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */
    .descripcion-plataforma .sirve { width: 45%; }
    
    /* PROMOCIÓN APP + FORMULARIO CONTACTO */
    .app-contacto{ 
      flex-direction: column;
      gap: 50px;
      margin: 80px 0px 0px 0px;
    }
    
    .promocion-app{ 
      width: fit-content;
      margin: 0 auto;
    }
    
    .formulario-contacto{ 
      display: flex; 
      flex-wrap: wrap;
      justify-content: space-between;
    }
    
    .formulario-contacto h2{ width: 100%; }
    .formulario-contacto .campo{ width: 45%; }
    .formulario-contacto button{ margin-left: auto; }
    
    /* ENLACES LEGALES */
    .enlaces-legales{ margin-top: 25px;}
    
    }
    
    
  @media (max-width: 1024px) {
    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */
    .descripcion-plataforma{ 
      flex-direction: column; 
      gap: 50px;
    }
    
    .descripcion-plataforma .que-es,
    .descripcion-plataforma .sirve
    { width: 100%; }
    
    .red-empleo p{ max-width: 441px; }
    
    /* PROMOCIÓN APP + FORMULARIO CONTACTO */
    .app-contacto { 
      margin: 50px 0px 0px 0px; 
      gap: 60px;
    }
    
    /* ENLACES LEGALES */
    .enlaces-legales{ margin-top: 35px; }
  }
  
  @media (max-width: 820px) {
    main{ margin: 120px 50px 100px 50px; }
    .landing-page { margin-bottom: 90px; }
    section { margin: 35px 0px; }
    
    /* FORMULARIO CONTACTO */
    .formulario-contacto .sobre-mi{ width: 100%; }
    .formulario-contacto .sobre-mi textarea{ height: 100px; }
    .formulario-contacto { padding: 30px 35px 35px 35px; }
    
  }
  
  
  @media (max-width: 768px) {
    section { margin: 25px 0px; }
    
    /* PROMOCIÓN APP + FORMULARIO CONTACTO */
    .promocion-app{ flex-direction: column; }
    .app-contacto { gap: 40px; }
    
    .promocion-app .promocion{ 
      display: flex;
      flex-direction: column;
      max-width: 100%;
      text-align: center;
    }
    
    .promocion-app .texto{ 
      max-width: 500px;
      margin: 0 auto 10px auto;
    }
    
    .promocion-app .descarga { margin: 10px 0 0 0; }
    .promocion-app .tiendas{ margin: 0 auto; }
    
    /* FORMULARIO CONTACTO */
    .formulario-contacto .campo{ width: 100%; }
  }
  

  @media (max-width: 600px) {
    .main{ width: 100%; }
    main{margin: 100px 7.5% 100px 7.5%;}

    .landing-page h1, .landing-page h2 { font-size: 18px; }

    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */
    .descripcion-plataforma .red-empleo{ flex-direction: column; }
    .descripcion-plataforma .red-empleo .logo-redempleo{ order: 1; }
    .descripcion-plataforma .red-empleo p{ 
      order: 0; 
      font-size: 16px;
      margin-bottom: 0px;
    }

    .promocion-app .texto,
    .promocion-app .texto span
    {font-size: 18px;}

    /* FORMULARIO CONTACTO */
    .formulario-contacto{
      min-width: 100%;
      max-width: 100%;
      padding: 20px 25px 20px 25px;
    }

    /* ENLACES LEGALES */
    .enlaces-legales { 
      margin-top: 15px; 
      gap: 15px 10px;
    }

    .enlaces-legales a{ font-size: 14px; }

    /* BANNER */
    .banner img { width: 95%; }
  }


`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage.css"],"names":[],"mappings":"AAAA;;kFAEkF;;AAElF;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA,GAAG,qBAAqB,EAAE;AAC1B,UAAU,0BAA0B,EAAE,eAAe,CAAC;;AAEtD,kBAAkB,gBAAgB,EAAE;;AAEpC,cAAc,eAAe,EAAE;;AAE/B,GAAG,gBAAgB,EAAE;;AAErB,MAAM,kBAAkB,EAAE;AAC1B,YAAY,6BAA6B,EAAE;;AAE3C,OAAO,aAAa,EAAE;;AAEtB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,MAAM,yBAAyB,EAAE;;AAEjC;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,YAAY,gBAAgB,EAAE;;AAE9B;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,OAAO,aAAa,EAAE;;AAEtB,QAAQ,cAAc,EAAE;AACxB,OAAO,cAAc,EAAE;AACvB,SAAS,YAAY,EAAE;AACvB,QAAQ,YAAY,EAAE;AACtB,cAAc,yBAAyB,EAAE;AACzC,eAAe,uBAAuB,EAAE;AACxC,aAAa,yBAAyB,EAAE;;AAExC,cAAc,yBAAyB,EAAE;AACzC,cAAc,0BAA0B,EAAE;;AAE1C,SAAS,eAAe,CAAC;AACzB,SAAS,eAAe,CAAC;AACzB,SAAS,eAAe,CAAC;;AAEzB,aAAa,kBAAkB,CAAC;AAChC,WAAW,gBAAgB,CAAC;AAC5B,YAAY,iBAAiB,CAAC;;AAE9B,OAAO,iBAAiB,EAAE;;AAE1B,QAAQ,eAAe,EAAE;AACzB,WAAW,kBAAkB,EAAE;AAC/B,WAAW,kBAAkB,EAAE;;AAE/B,YAAY,kBAAkB,EAAE;AAChC,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,QAAQ,UAAU,EAAE;AACpB,SAAS,WAAW,EAAE;;AAEtB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,WAAW,EAAE;AACpB,OAAO,YAAY,EAAE;AACrB,QAAQ,WAAW,EAAE;AACrB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;AACtB,QAAQ,YAAY,EAAE;;AAEtB,QAAQ,QAAQ,EAAE;AAClB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,SAAS,SAAS,EAAE;AACpB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,WAAW,cAAc,CAAC;;AAE1B,OAAO,mBAAmB,EAAE;AAC5B,QAAQ,oBAAoB,EAAE;AAC9B,OAAO,kBAAkB,EAAE;AAC3B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,SAAS,oBAAoB,EAAE;AAC/B,OAAO,eAAe,CAAC;AACvB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,QAAQ,gBAAgB,CAAC;AACzB,OAAO,gBAAgB,CAAC;AACxB,QAAQ,iBAAiB,CAAC;AAC1B,QAAQ,iBAAiB,CAAC;AAC1B,OAAO,iBAAiB,CAAC;AACzB,QAAQ,kBAAkB,CAAC;AAC3B,QAAQ,kBAAkB,CAAC;AAC3B,OAAO,kBAAkB,CAAC;;AAE1B,YAAY,YAAY,EAAE;;AAE1B,eAAiC,oBAAoB;IAGjD,gBAAgB,EAHmC;;;AAOvD,SAAS,eAAe,EAAE;;AAE1B,IAAI,2BAA2B,EAAE;;AAEjC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB,eAAe,EAAE;;;AAGnC;;kFAEkF;AAClF;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB,mBAAmB,CAAC;AACpC,iBAAiB,mBAAmB,CAAC;;AAErC;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,6CAA6C,iBAAiB,EAAE;AAChE,gCAAgC,UAAU,EAAE;;;AAG5C;;kFAEkF;AAClF;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,sCAAsC,uBAAuB,EAAE;;AAE/D,8BAA8B,YAAY,EAAE;AAC5C,oCAAoC,YAAY,EAAE;;AAElD;;kFAEkF;AAClF;AACA,mBAAmB;AACnB,4BAA4B;AAC5B,gBAAgB;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB;;AAEF,6BAA6B,mBAAmB,EAAE;;AAElD;;AAEA,YAAY;AACZ,6BAA6B;AAC7B,wBAAwB;AACxB,6BAA6B;AAC7B,YAAY;AACZ;;AAEA;AACA,sBAAsB;AACtB,kBAAkB;AAClB,iBAAiB;AACjB;;AAEA;4CAC4C,0CAA0C,EAAE;;AAExF,mCAAmC,uBAAuB,EAAE;;AAE5D;;kFAEkF;AAClF;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB,YAAY,EAAE;AAClC,0BAA0B,0BAA0B,EAAE;;AAEtD;EACE;IACE,iBAAiB;AACrB;AACA;;AAEA;;kFAEkF;EAChF;IACE,kBAAkB;IAClB,eAAe,0BAA0B,EAAE;EAC7C;;;;;EAKA;IACE,UAAU,gBAAgB,EAAE;;IAE5B,kDAAkD;IAClD,iCAAiC,UAAU,EAAE;;IAE7C,wCAAwC;IACxC;MACE,sBAAsB;MACtB,SAAS;MACT,wBAAwB;IAC1B;;IAEA;MACE,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,eAAe;MACf,8BAA8B;IAChC;;IAEA,yBAAyB,WAAW,EAAE;IACtC,6BAA6B,UAAU,EAAE;IACzC,6BAA6B,iBAAiB,EAAE;;IAEhD,oBAAoB;IACpB,kBAAkB,gBAAgB,CAAC;;IAEnC;;;EAGF;IACE,kDAAkD;IAClD;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;;MAEE,WAAW,EAAE;;IAEf,eAAe,gBAAgB,EAAE;;IAEjC,wCAAwC;IACxC;MACE,wBAAwB;MACxB,SAAS;IACX;;IAEA,oBAAoB;IACpB,kBAAkB,gBAAgB,EAAE;EACtC;;EAEA;IACE,MAAM,6BAA6B,EAAE;IACrC,gBAAgB,mBAAmB,EAAE;IACrC,UAAU,gBAAgB,EAAE;;IAE5B,wBAAwB;IACxB,gCAAgC,WAAW,EAAE;IAC7C,yCAAyC,aAAa,EAAE;IACxD,uBAAuB,4BAA4B,EAAE;;EAEvD;;;EAGA;IACE,UAAU,gBAAgB,EAAE;;IAE5B,wCAAwC;IACxC,gBAAgB,sBAAsB,EAAE;IACxC,gBAAgB,SAAS,EAAE;;IAE3B;MACE,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;;IAEA,2BAA2B,kBAAkB,EAAE;IAC/C,yBAAyB,cAAc,EAAE;;IAEzC,wBAAwB;IACxB,6BAA6B,WAAW,EAAE;EAC5C;;;EAGA;IACE,OAAO,WAAW,EAAE;IACpB,KAAK,6BAA6B,CAAC;;IAEnC,qCAAqC,eAAe,EAAE;;IAEtD,kDAAkD;IAClD,qCAAqC,sBAAsB,EAAE;IAC7D,qDAAqD,QAAQ,EAAE;IAC/D;MACE,QAAQ;MACR,eAAe;MACf,kBAAkB;IACpB;;IAEA;;KAEC,eAAe,CAAC;;IAEjB,wBAAwB;IACxB;MACE,eAAe;MACf,eAAe;MACf,4BAA4B;IAC9B;;IAEA,oBAAoB;IACpB;MACE,gBAAgB;MAChB,cAAc;IAChB;;IAEA,oBAAoB,eAAe,EAAE;;IAErC,WAAW;IACX,cAAc,UAAU,EAAE;EAC5B","sourcesContent":["/* -----------------------------------------------------------------------------\n// GLOBALS\n// ----------------------------------------------------------------------------- */\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Quicksand', sans-serif;\n    font-size: 16px;\n    line-height: 1.5;\n}\n\na{ text-decoration: none; }\na:hover { text-decoration: underline; cursor: pointer;}\n\np, li, a, button{ font-weight: 500; }\n\nbutton:hover{ cursor: pointer; }\n\np{ line-height: 1.2; }\n\nmain{ margin: 270px 80px; }\n.main-user{ margin: 140px 80px 100px 80px; }\n\n.flex{ display: flex; }\n\n.column{\n  display: flex;\n  flex-direction: column;\n}\n\n.between{\n  display: flex;\n  justify-content: space-between;\n}\n\n.end{ justify-content: flex-end; }\n\n.flex-center{\n  display: flex;\n  justify-content: center;\n}\n\n.align-center {\n  display: flex;\n  align-items: center;\n}\n\n.align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n.align-end{ align-items: end; }\n\n.wrap{\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.none{ display: none; }\n\n.verde{ color: #007932; }\n.rojo{ color: #8E151D; }\n.blanco{ color: white; }\n.negro{ color: black; }\n.fondo-verde{ background-color: #007932; }\n.fondo-blanco{ background-color: white; }\n.fondo-rojo{ background-color: #8E151D; }\n\n.mayusculas { text-transform: uppercase; }\n.capitalize { text-transform: capitalize; }\n\n.font-18{font-size: 18px;}\n.font-21{font-size: 21px;}\n.font-24{font-size: 24px;}\n\n.text-center{text-align: center;}\n.text-left{text-align: left;}\n.text-right{text-align: right;}\n\n.bold{ font-weight: bold; }\n\n.fixed{ position: fixed; }\n.absolute{ position: absolute; }\n.relative{ position: relative; }\n\n.w-content{ width: fit-content; }\n.w-10p{ width: 10%; }\n.w-20p{ width: 20%; }\n.w-25p{ width: 25%; }\n.w-30p{ width: 30%; }\n.w-50p{ width: 50%; }\n.w-60p{ width: 60%; }\n.w-70p{ width: 70%; }\n.w-75p{ width: 75%; }\n.w-80p{ width: 80%; }\n.w-90p{ width: 90%; }\n.w-100p{ width: 100%; }\n\n.w-50{ width: 50px; }\n.w-25{ width: 25px; }\n.w-65{ width: 65px; }\n.w-75{ width: 75px; }\n.w-40{ width: 40px; }\n.w-80{ width: 80px; }\n.w-90{ width: 90px; }\n.w100{ width: 100px; }\n.w-100{ width: 100%; }\n.w-120{ width: 120px; }\n.w-150{ width: 150px; }\n.w-175{ width: 175px; }\n.w-180{ width: 180px; }\n.w-200{ width: 200px; }\n.w-250{ width: 250px; }\n.w-275{ width: 275px; }\n.w-300{ width: 300px; }\n.w-325{ width: 325px; }\n.w-350{ width: 350px; }\n.w-400{ width: 400px; }\n.w-450{ width: 450px; }\n.w-500{ width: 500px; }\n.w-550{ width: 550px; }\n\n.gap-5{ gap: 5px; }\n.gap-10{ gap: 10px; }\n.gap-15{ gap: 15px; }\n.gap-20{ gap: 20px; }\n.gap-25{ gap: 25px; }\n.gap-30{ gap: 30px; }\n.gap-50{ gap: 50px; }\n.gap-75{ gap: 75px; }\n.gap-100{ gap: 100px; }\n.gap-150{ gap: 150px; }\n.gap-200{ gap: 200px; }\n.gap-10-20{gap: 10px 20px;}\n\n.pb-5{ padding-bottom: 5px; }\n.pb-10{ padding-bottom: 10px; }\n.mb-5{ margin-bottom: 5px; }\n.mb-10{ margin-bottom: 10px; }\n.mb-20{ margin-bottom: 20px; }\n.mb-25{ margin-bottom: 25px; }\n.mb-30{ margin-bottom: 30px; }\n.mb-40{ margin-bottom: 40px; }\n.mb-50{ margin-bottom: 50px; }\n.mb-75{ margin-bottom: 75px; }\n.mb-100{ margin-bottom: 100px; }\n.mt-5{ margin-top: 5px;}\n.mt-10{ margin-top: 10px;}\n.mt-15{ margin-top: 15px;}\n.mt-20{ margin-top: 20px;}\n.mt-30{ margin-top: 30px;}\n.mt-50{ margin-top: 50px;}\n.ml-5{ margin-left: 5px;}\n.ml-10{ margin-left: 10px;}\n.ml-40{ margin-left: 40px;}\n.pl-5{ padding-left: 5px;}\n.pl-10{ padding-left: 10px;}\n.pl-20{ padding-left: 20px;}\n.mr-20{margin-right: 20px;}\n\n.no-border{ border: none; }\n\n.landing-page{ margin-top: 80px; margin-bottom: 130px; }\n\n.landing-page{\n    margin-top: 80px;\n}\n\n\n.cursor{ cursor: pointer; }\n\nul{ list-style-position: inside; }\n\n.boton{\n  padding: 10px 15px;\n  border: 2px solid #007932;\n  border-radius: 12px;\n  background-color: white;\n  color: #007932;\n  height: fit-content;\n}\n\n.boton:hover{\n  color: white;\n  background-color: #007932; \n  text-decoration: none;\n}\n\n/* -- Estilo para los titulos de las paginas de usuario -- */\n.titulo-user{\n  font-size: 242x;\n  line-height: 1.1;\n  gap: 10px;\n}\n\n.titulo-user svg{ font-size: 36px; }\n\n\n/* -----------------------------------------------------------------------------\n// DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE\n// ----------------------------------------------------------------------------- */\n.landing-page h1, .landing-page h2{\n  font-size: 24px;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.landing-page p{margin-bottom: 15px;}\n.landing-page li{margin-bottom: 10px;}\n\n.descripcion-plataforma .red-empleo{\n  margin-top: 20px;\n  gap: 20px;\n  align-items: center;\n}\n\n.descripcion-plataforma .logo-red{\n  width: 120px;\n  padding-top: 3px;\n}\n\n.descripcion-plataforma .red-empleo a, .descripcion-plataforma .red-empleo p{\n  font-size: 17px;\n  line-height: 1.2;\n}\n\n.descripcion-plataforma .red-empleo a{\n  color: #007932; \n  text-decoration: underline;\n}\n\n.descripcion-plataforma .red-empleo a:hover{ font-weight: bold; }\n.descripcion-plataforma .sirve{ width: 35%; }\n\n\n/* -----------------------------------------------------------------------------\n// PROMOCIÓN APP\n// ----------------------------------------------------------------------------- */\n.app-contacto{\n  justify-content: space-between;\n  padding: 25px 100px 25px 100px;\n}\n\n.promocion-app{\n  align-items: center;\n  gap: 30px;\n}\n\n.promocion-app .promocion{ \n  min-width: 300px; \n  max-width: 300px; \n}\n\n.promocion-app .texto, .promocion-app .texto span{\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1.2;\n}\n\n.promocion-app .descarga{ margin: 30px 0 0 0; }\n\n.promocion-app .tiendas{ \n  gap: 7.5px;\n  margin-left: -4px;\n}\n\n.promocion-app .tiendas button:hover{ background-color: white; }\n\n.promocion-app .tiendas img{  width: 120px; }\n.promocion-app .tiendas img:hover{  opacity: 0.7; }\n\n/* -----------------------------------------------------------------------------\n// FORMULARIO CONTACTO\n// ----------------------------------------------------------------------------- */\n.formulario-contacto{\nborder-radius: 20px;\npadding: 30px 35px 40px 35px;\nmin-width: 400px;\n}\n\n.formulario-contacto h2{\n  margin: 0px auto 20px auto;\n  width: 300px;\n  text-align: center;\n  }\n\n.formulario-contacto .campo{ margin-bottom: 25px; }\n\n.formulario-contacto input,\n.formulario-contacto textarea{ \nborder: none;\nborder-bottom: 1px solid #fff;\npadding: 2px 5px 1px 5px;\nbackground-color: transparent;\ncolor: white;\n}\n\n.formulario-contacto .campo textarea{ \nborder: 1px solid #fff; \nborder-radius: 5px;\nmargin-top: 2.5px;\n}\n\n.formulario-contacto input::placeholder,\n.formulario-contacto textarea::placeholder{ color: rgba(255, 255, 255, 0.5) !important; }\n\n.formulario-contacto button:hover{ border: 2px solid white; }\n\n/* -----------------------------------------------------------------------------\n// ENLACES LEGALES\n// ----------------------------------------------------------------------------- */\n.enlaces-legales{ \n  flex-wrap: wrap;\n  gap: 20px 30px; \n}\n\n.enlaces-legales a{ color: black; }\n.enlaces-legales a:hover{ text-decoration: underline; }\n\n@media(min-width: 1024px){\n  .landing-page {\n    margin-top: 210px;\n}\n}\n\n/* -----------------------------------------------------------------------------\n// RESPONSIVE\n// ----------------------------------------------------------------------------- */\n  @media (max-width: 1400px) {\n    /* PROMOCIÓN APP */\n    .app-contacto{ padding: 25px 0px 25px 0px; }\n  }\n\n\n  \n  \n  @media (max-width: 1200px) {\n    section { margin: 60px 0px; }\n    \n    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */\n    .descripcion-plataforma .sirve { width: 45%; }\n    \n    /* PROMOCIÓN APP + FORMULARIO CONTACTO */\n    .app-contacto{ \n      flex-direction: column;\n      gap: 50px;\n      margin: 80px 0px 0px 0px;\n    }\n    \n    .promocion-app{ \n      width: fit-content;\n      margin: 0 auto;\n    }\n    \n    .formulario-contacto{ \n      display: flex; \n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n    \n    .formulario-contacto h2{ width: 100%; }\n    .formulario-contacto .campo{ width: 45%; }\n    .formulario-contacto button{ margin-left: auto; }\n    \n    /* ENLACES LEGALES */\n    .enlaces-legales{ margin-top: 25px;}\n    \n    }\n    \n    \n  @media (max-width: 1024px) {\n    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */\n    .descripcion-plataforma{ \n      flex-direction: column; \n      gap: 50px;\n    }\n    \n    .descripcion-plataforma .que-es,\n    .descripcion-plataforma .sirve\n    { width: 100%; }\n    \n    .red-empleo p{ max-width: 441px; }\n    \n    /* PROMOCIÓN APP + FORMULARIO CONTACTO */\n    .app-contacto { \n      margin: 50px 0px 0px 0px; \n      gap: 60px;\n    }\n    \n    /* ENLACES LEGALES */\n    .enlaces-legales{ margin-top: 35px; }\n  }\n  \n  @media (max-width: 820px) {\n    main{ margin: 120px 50px 100px 50px; }\n    .landing-page { margin-bottom: 90px; }\n    section { margin: 35px 0px; }\n    \n    /* FORMULARIO CONTACTO */\n    .formulario-contacto .sobre-mi{ width: 100%; }\n    .formulario-contacto .sobre-mi textarea{ height: 100px; }\n    .formulario-contacto { padding: 30px 35px 35px 35px; }\n    \n  }\n  \n  \n  @media (max-width: 768px) {\n    section { margin: 25px 0px; }\n    \n    /* PROMOCIÓN APP + FORMULARIO CONTACTO */\n    .promocion-app{ flex-direction: column; }\n    .app-contacto { gap: 40px; }\n    \n    .promocion-app .promocion{ \n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      text-align: center;\n    }\n    \n    .promocion-app .texto{ \n      max-width: 500px;\n      margin: 0 auto 10px auto;\n    }\n    \n    .promocion-app .descarga { margin: 10px 0 0 0; }\n    .promocion-app .tiendas{ margin: 0 auto; }\n    \n    /* FORMULARIO CONTACTO */\n    .formulario-contacto .campo{ width: 100%; }\n  }\n  \n\n  @media (max-width: 600px) {\n    .main{ width: 100%; }\n    main{margin: 100px 7.5% 100px 7.5%;}\n\n    .landing-page h1, .landing-page h2 { font-size: 18px; }\n\n    /* DESCRIPCIÓN DE LA PLATAFORMA Y PARA QUE SIRVE */\n    .descripcion-plataforma .red-empleo{ flex-direction: column; }\n    .descripcion-plataforma .red-empleo .logo-redempleo{ order: 1; }\n    .descripcion-plataforma .red-empleo p{ \n      order: 0; \n      font-size: 16px;\n      margin-bottom: 0px;\n    }\n\n    .promocion-app .texto,\n    .promocion-app .texto span\n    {font-size: 18px;}\n\n    /* FORMULARIO CONTACTO */\n    .formulario-contacto{\n      min-width: 100%;\n      max-width: 100%;\n      padding: 20px 25px 20px 25px;\n    }\n\n    /* ENLACES LEGALES */\n    .enlaces-legales { \n      margin-top: 15px; \n      gap: 15px 10px;\n    }\n\n    .enlaces-legales a{ font-size: 14px; }\n\n    /* BANNER */\n    .banner img { width: 95%; }\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
